import PropTypes from 'prop-types'

import { Transfer, Table } from 'antd'

const TableTransfer = ({ leftColumns, rightColumns, ...restProps }) => (
  <Transfer {...restProps} showSearch showSelectAll={false}>
    {({
      direction,
      filteredItems,
      onItemSelect,
      onItemSelectAll,
      selectedKeys: listSelectedKeys,
    }) => {
      const columns = direction === 'left' ? leftColumns : rightColumns
      const rowSelection = {
        // getCheckboxProps: () => ({
        //   disabled: listDisabled,
        // }),
        onChange(selectedRowKeys) {
          onItemSelectAll(selectedRowKeys, 'replace')
        },
        selectedRowKeys: listSelectedKeys,
        selections: [
          Table.SELECTION_ALL,
          // Table.SELECTION_INVERT,
          Table.SELECTION_NONE,
        ],
      }
      return (
        <Table
          rowSelection={rowSelection}
          columns={columns}
          bordered={false}
          dataSource={filteredItems}
          size="small"
          pagination={false}
          scroll={{ y: 150 }}
          //   style={{
          //     pointerEvents: listDisabled ? 'none' : undefined,
          //   }}
          onRow={({ key }) => ({
            onClick: () => {
              //   if (itemDisabled || listDisabled) {
              //     return
              //   }
              onItemSelect(key, !listSelectedKeys.includes(key))
            },
          })}
        />
      )
    }}
  </Transfer>
)

TableTransfer.propTypes = {
  leftColumns: PropTypes.any,
  rightColumns: PropTypes.any,
}
export default TableTransfer
